import { communicationsDocumentsMessages } from '../../../messages';
import { Column } from '../../column';
import { CommunicationsDocument } from '../communications';

export const communicationsColumns: Column<CommunicationsDocument>[] = [
  {
    headerLabel: communicationsDocumentsMessages.CommunicationsTableTitleLabel,
    key: 'title',
    type: 'react-node',
  },
  {
    headerLabel:
      communicationsDocumentsMessages.CommunicationsTableDocumentTypeLabel,
    key: 'code',
    type: 'string',
  },
  {
    headerLabel:
      communicationsDocumentsMessages.CommunicationsTablePublicationDateLabel,
    key: 'uploadDate',
    type: 'date',
  },
  {
    headerLabel:
      communicationsDocumentsMessages.CommunicationsTableJurisdictionDateLabel,
    key: 'jurisdictionDate',
    type: 'date',
  },
  {
    headerLabel: null,
    key: 'flagIsRead',
    type: 'react-node',
  },
];
